import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import { ApprovalSubmissionInterface } from 'features/AdsManagement/@types/apiTypes'

export const SLICE_NAME = 'adsPrincipalList'

type PaginationStateType = {
  next_cursor: string
  prev_cursor: string
}

interface AdsPrincipalDetailReduxInterface {
  isLoading: boolean
  principalDetail: ApprovalSubmissionInterface[]
  pagination: PaginationStateType
}

const initialState: AdsPrincipalDetailReduxInterface = {
  isLoading: false,
  principalDetail: [],
  pagination: { next_cursor: '', prev_cursor: '' },
}
const adsPrincipalDetailListSlice = createSlice({
  name: SLICE_NAME,
  initialState,
  reducers: {
    setIsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload
    },
    setPrincipalDetail: (state, action: PayloadAction<ApprovalSubmissionInterface[]>) => {
      state.principalDetail = action.payload
    },
    setPagination: (state, action: PayloadAction<PaginationStateType>) => {
      state.pagination = action.payload
    },
  },
})

export const { setIsLoading, setPrincipalDetail, setPagination } =
  adsPrincipalDetailListSlice.actions

export default adsPrincipalDetailListSlice.reducer
